import React from "react";

import BurgerNavHeaderMenuContainer from "core/Components/HamburgerNavigations/large/BurgerNavHeaderMenuContainer";
import BurgerNavHeaderMenuChevron from "core/Components/HamburgerNavigations/large/BurgerNavHeaderMenuChevron";
import BurgerNavHeaderMenuTitle from "core/Components/HamburgerNavigations/large/BurgerNavHeaderMenuTitle";

type Props = {
    headerMenu: StandardPage,
    currentURLSegment?: string,
    selectedHeaderMenu?: StandardPage,
    selectedSegments?: string[],
    getSubMenu: Function,
    setSubMenu: Function,
    closeMenuHandler: Function,
    isBurgerMenuClick: boolean,
};

const BurgerNavHeaderMenuBox: React.FC<Props> = ({
    headerMenu,
    currentURLSegment = "",
    selectedHeaderMenu = undefined,
    selectedSegments = undefined,
    getSubMenu,
    setSubMenu,
    closeMenuHandler,
    isBurgerMenuClick,
}) => {
    const submenu = getSubMenu(headerMenu);
    const hasSubMenu = submenu?.standardPage && (
        submenu.standardPage.length > 1 || (submenu.standardPage.length === 1 && submenu.standardPage[0].showInMenus)
    );

    return (
        <BurgerNavHeaderMenuContainer
            headerMenu={headerMenu}
            currentURLSegment={currentURLSegment}
            selectedHeaderMenu={selectedHeaderMenu}
            selectedSegments={selectedSegments}
            hasSubMenu={hasSubMenu}
            setSubMenu={setSubMenu}
            closeMenuHandler={closeMenuHandler}
            isBurgerMenuClick={isBurgerMenuClick}
        >
            <BurgerNavHeaderMenuTitle>{headerMenu.title}</BurgerNavHeaderMenuTitle>

            {hasSubMenu && (
                <BurgerNavHeaderMenuChevron />
            )}
        </BurgerNavHeaderMenuContainer>
    );
};

export default BurgerNavHeaderMenuBox;